import EntityDisplay from '../EntityElements/EntityDisplay';
import { HubNpcPlacement } from '../../../types/hub.types';
import { DirectionEnum } from '../../../types/enums';

const DEFAULT_ANCHOR: [number, number] = [0.5, 1];

// `npc.y` is in PNG-coords (Y downward). EntityDisplay works in Y-up, so the
// Y component is negated on the way in.
export const HubNpcSprite = ({ npc }: { npc: HubNpcPlacement }) => {
  if (!npc.spriteName) {
    return null;
  }
  return (
    <EntityDisplay
      clip={{
        spriteName: npc.spriteName,
        direction: npc.facing ?? DirectionEnum.BOTTOM,
        width: npc.spriteWidth,
        height: npc.spriteHeight,
        anchor: npc.spriteAnchor ?? DEFAULT_ANCHOR,
        loop: true,
      }}
      position={{ x: npc.x, y: -npc.y }}
    />
  );
};
